<template>
  <div class="details-list">
    <div v-if="user.portfolio && user.portfolio.length > 0">
      <div class="detail-item">
        <span class="b course-header">Name of RoundTable</span>
      </div>
      <div
        class="detail-item"
        v-for="(rt, index) in user.portfolio"
        :key="index"
      >
        <span class="portfolio-link tl">
          <a class="flex" :href="`${universeUrl}/` + (rt.type === 'online' ? 'roundtables' : 'live_discussions') + `/${rt.id}`" target="_blank">
            {{ rt.title }}
            <i class="fas fa-external-link-alt"></i>
          </a>
        </span>
      </div>
    </div>
    <div v-else class="center-xs" style="padding-top: 10px;">
      <span> No RoundTables </span>
    </div>
  </div>
</template>

<script>
  import urlConfigs from 'services/apiConfigs';

  export default {
    data(){
      return {
        universeUrl : undefined,
      };
    },
    props: {
      user: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    mounted(){
      this.universeUrl = urlConfigs.universeURL;
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus'

  .details-list
    overflow-y: scroll
    max-height: 60vh
    .detail-item
      display flex
      justify-content space-between
      padding .5rem 1rem
      border-bottom 1px solid pl-fog
    .portfolio-link
      a
        color: #78BEC8
        :hover
          text-decoration underline
        i
          align-self start
          font-size 6px
          padding 4px
    .course-header
      font-size 12px
      text-align center

  ::-webkit-scrollbar {
    display: block;
    width: 10px
    -webkit-appearance: none;
  }
</style>



// WEBPACK FOOTER //
// portfolioTabContent.vue?6dfa2fe9